<template>
  <div
    v-show="notices.length > 0"
    style="margin-top:70px;min-width:50vw;max-width:80vw;word-wrap: break-word;"
    class="w3-panel w3-yellow w3-round w3-card-4 w3-display-topmiddle"
  >
    <span
      style="position:absolute;top:5px;right:5px;"
      class="w3-button w3-large"
      onclick="this.parentElement.style.display='none';"
      >&times;</span
    >
    <h3 style="text-decoration-line:underline; text-decoration-style:solid">
      Notice
    </h3>
    <ul>
      <li v-for="notice in notices" v-bind:key="notice.id">
        <p>
          {{ notice.noticeText }}
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import DataService from "@/services/DataService";
export default {
  name: "NoticeDisplay",
  data() {
    return {
      notices: [],
    };
  },
  methods: {
    async getNotices() {
      const response = await DataService.getNoticesFromApi();
      if (response.data) {
        this.notices = response.data;
      }
    },
  },
  created() {
    this.getNotices();
  },
};
</script>

<style></style>
